import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import GitHubIcon from '@mui/icons-material/GitHub';
const Cards = (props)=> {
    return (
        <>
      <Card sx={{ maxWidth: 345 }}>
      <CardMedia
        component="img"
        height={props.height}
        image={props.img}
        alt={props.alt}
        sx={{image: {objectFit: "cover"}}}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
         {props.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {props.desc}
        </Typography>
      </CardContent>
      <CardActions sx={{display:"flex" , justifyContent:"center" , marginBottom:"3px" , }}>
        <Button size="small" variant="outlined" sx={{textTransform:"none"}} href={props.link} startIcon={<GitHubIcon />}>Source</Button>
        
      </CardActions>
    </Card>
        </>
    )
}
export default Cards;
